/**
 * Core GraphQL — games played inside a chat (`/api/core/graphql/`). A game is one message whose
 * board every move updates.
 */

/** Everything a game card shows. */
export const CHAT_GAME_FIELDS = `
  id kind status turn state winnerId winLine lastMove movesCount mySeat score messageId
  invitedId clockMs clockMinutes drawOfferedBy
  players { userId username fullName profile { avatarUrl } }
  watchers { userId username fullName }
`;

/** What the chat lists need for "🎮 Your turn in XO" or "🎮 Sara challenges you to Chess". */
export const CHAT_GAME_PREVIEW_FIELDS = "kind status turn mySeat winnerId invitedId players { userId fullName }";

export const CORE_QUERY_CHAT_GAME = `
  query ChatGame($gameId: Int!) {
    chatGame(gameId: $gameId) { ${CHAT_GAME_FIELDS} }
  }
`;
